/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */


import { CommonDataPayload, PageDataPayload, SearchTermPayload, UserDataPayload } from '@/data/types/GTM';
import { sendGTMCommonviewEvent, sendGTMSearchTermDataEvent, sendGTMUserDataEvent, sendGTMXPageViewEvent } from '../handlers/gtm/GACommonData';

export type CommonDataDelegatorProps = {
	gtm?: CommonDataPayload;
};
export type UserDataDelegatorProps = {
	gtm?: UserDataPayload;
};
export  type PageDataDelegatorProps = {
	gtm?: PageDataPayload
};
export  type SearchTermDelegatorProps = {
	gtm?: SearchTermPayload
};

export const commonViewDelegator = async (payload: CommonDataDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMCommonviewEvent(gtm);
	}
};

export const xPageViewDelegator = async (payload: PageDataDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMXPageViewEvent(gtm);
	}
};


export const userDataViewDelegator = async (payload: UserDataDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMUserDataEvent(gtm);
	}
};

export const searchTermToGADelegator = async (payload: SearchTermDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMSearchTermDataEvent(gtm);
	}
};
